import { render, staticRenderFns } from "./ApplyNoStudy.vue?vue&type=template&id=61c23273&scoped=true"
import script from "./ApplyNoStudy.vue?vue&type=script&lang=js"
export * from "./ApplyNoStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c23273",
  null
  
)

export default component.exports